<div class="rename-category-modal-wrapper">
    <div class="header-wrapper">
        <img
            src="assets/svg/img-db/classificator-tree/swap.svg"
            alt="swap-icon"
        />
        <span>{{
            'imgDb.classificatorTree.renameCategoryDialog.header' | translate
        }}</span>
    </div>
    <div class="category-selection-wrapper">
        <div class="header">
            <div class="left-side">
                <span>{{
                    'imgDb.classificatorTree.renameCategoryDialog.categorySelection.header.left'
                        | translate
                }}</span>
            </div>
            <div class="right-side">
                <span>{{
                    'imgDb.classificatorTree.renameCategoryDialog.categorySelection.header.right'
                        | translate
                }}</span>
            </div>
        </div>
        <div class="separation-line"></div>
        <div class="content">
            <div class="left-side">
                <span>{{ annotation }}</span>
            </div>
            <div class="right-side">
                <select
                    id="category-selection-dropdown"
                    [formControl]="selectedCategoryControl"
                    (change)="onSelectionChange()"
                >
                    <option
                        class="category-option"
                        *ngFor="let category of categories"
                        [value]="category"
                        [id]="category + '-option'"
                    >
                        {{ category }}
                    </option>
                </select>
            </div>
        </div>
    </div>
    <div class="buttons-wrapper">
        <div class="button cancel" (click)="onCancel()">
            {{
                'imgDb.classificatorTree.renameCategoryDialog.buttons.cancel'
                    | translate
            }}
        </div>
        <div class="button apply" (click)="onApply()">
            {{
                'imgDb.classificatorTree.renameCategoryDialog.buttons.apply'
                    | translate
            }}
        </div>
    </div>
</div>
